const AppSettings = {
  appTitle: 'App',
  apiUrl: '/api/v1'
};

export default AppSettings;
